import {Field, useFormikContext} from 'formik'
import React, {Fragment, useEffect, useState} from 'react'
import {Grid, Grow, Typography} from '@material-ui/core'

import CustomDialog from '../../../../components/CustomDialog'
import SelectField from '../../../../components/SelectField'
import WebcamCapture from '../../../../components/Webcam'
import {StepHeader} from '../../styles'

import DocumentsImage from '../../../../assets/document.png'
import IdFrameFront from '../../../../assets/SVG/moldura-rg-frente.svg'
import CnhFrameFront from '../../../../assets/SVG/cnh-frente.svg'
import RneFrameFront from '../../../../assets/SVG/rne-frente.svg'

const frames = {
  IDENTITY_CARD_FRONT: IdFrameFront,
  DRIVER_LICENSE_FRONT: CnhFrameFront,
  RNE_FRONT: RneFrameFront,
}

const Step10 = () => {
  const [instructionsOpen, setInstructionsOpen] = useState(true)
  const {setFieldValue, setFieldTouched, values} = useFormikContext()
  const {documentType} = values
  useEffect(() => {
    setFieldValue('documentType', '')
    setFieldValue('image', '')
    setFieldTouched('documentType', false)
    setFieldTouched('image', false)
  }, [setFieldTouched, setFieldValue])
  return (
    <Fragment>
      <CustomDialog
        open={instructionsOpen}
        onClose={() => setInstructionsOpen(false)}
        image={DocumentsImage}
        title="Hora de enviar seus documentos"
        description="Quando estiver fotografando certifique-se de deixar um espaço entre bordas do documento e o limite da foto, de acordo com a moldura."
        actionText="Certo, Entendido"
      />
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            variant="body1"
            gutterBottom
            color="textPrimary">
            Passo 3 de 3
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            color="textPrimary">
            Vamos precisar de uma foto da frente do seu documento.
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              label="Tipo de documento"
              native
              name="documentType"
              component={SelectField}
            >
              <option aria-label="None" value="" />
              <option value="DRIVER_LICENSE_FRONT">CNH - Frente</option>
              <option value="IDENTITY_CARD_FRONT">RG - Frente</option>
              <option value="RNE_FRONT">Registro Nacional de Estrangeiro - Frente</option>
              <option value="EMANCIPATION_STATEMENT">Carta de Emancipação</option>
              <option value="PASSPORT">Passaporte</option>
            </Field>
          </Grid>
          <Grid item xs={12}>
            <Field
              frame={frames[documentType]}
              name="image"
              facingMode="environment"
              component={WebcamCapture}
            />
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  );
};

export default Step10;
